import { useQuery } from '@tanstack/react-query';

import { useAuthentication } from '../../Idp/useAuthentication';
import { useLedgerApi } from '../api';
import { ICauseLedger } from '../types';
import { UserBalancesResponse } from './types';

// React Query: doc: Use Placeholder. This is particularly useful if we don't wan't to block rendering
// And we know that some type of data should be there.
export function useUserBalances() {
  const { isAuthenticated } = useAuthentication();
  const LedgerApi = useLedgerApi();
  const getBalances = async () => {
    const { data } = await LedgerApi.get<UserBalancesResponse>('/balances');
    return data;
  };

  return useQuery({
    queryKey: ['ledger', 'balances'],
    queryFn: getBalances,
    placeholderData: {
      available: 0,
      held: {},
      pending: {},
      permanent: {},
    } as UserBalancesResponse,
    enabled: !!isAuthenticated,
  });
}
// TODO: Deprecate: apps/givebacks.js/src/hooks/queries/Ledger/owner.ts:useUserBalances

export function useShowCauseLedger(uuid: string | undefined) {
  const LedgerApi = useLedgerApi();

  const causeLedger = async () => {
    const { data } = await LedgerApi.get<ICauseLedger>(`/causes/${uuid}`);
    return data.cause;
  };

  return useQuery({
    queryKey: ['ledger', 'cause', uuid],
    queryFn: causeLedger,
    enabled: Boolean(uuid),

    placeholderData: {
      type: '',
      entry_privacy: '',
      donate_cashback: false,
      lifetime_cashback: 0.0,
      lifetime_donations: 0,
      lifetime_payouts: 0,
      lifetime_transfers: 0,
      uuid: '',
      created_at: '',
      updated_at: '',
      yearly_donations: {
        count: 0,
        sum: 0,
        average: 0,
        percentage_to_goal: 0,
      },
    },
  });
}
